import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SchoolIcon from '@mui/icons-material/School';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'grey.300',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="grey.100" gutterBottom>
              Minimal APIs
            </Typography>
            <Typography variant="body2">
              .NET Core ile modern web API geliştirme platformu.
              Samsun Üniversitesi Yazılım Mühendisliği Bölümü.
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="grey.100" gutterBottom>
              Hızlı Bağlantılar
            </Typography>
            <Box>
              {[
                { text: 'Dersler', href: '/courses' },
                { text: 'Sunumlar', href: '/presentations' },
                { text: 'Sınavlar', href: '/exams' },
                { text: 'Hakkında', href: '/about' },
              ].map((link) => (
                <Link
                  key={link.text}
                  href={link.href}
                  sx={{
                    display: 'block',
                    color: 'grey.400',
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      color: 'grey.100',
                    },
                  }}
                >
                  {link.text}
                </Link>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="grey.100" gutterBottom>
              Sosyal Medya
            </Typography>
            <Box>
              <IconButton
                href="https://github.com/zcomert"
                target="_blank"
                sx={{ color: 'grey.400', '&:hover': { color: 'grey.100' } }}
              >
                <GitHubIcon />
              </IconButton>
              <IconButton
                href="https://www.youtube.com/@virtual.campus"
                target="_blank"
                sx={{ color: 'grey.400', '&:hover': { color: 'grey.100' } }}
              >
                <YouTubeIcon />
              </IconButton>
              <IconButton
                href="https://scholar.google.com.tr/citations?user=jn5XC4YAAAAJ&hl=tr"
                target="_blank"
                sx={{ color: 'grey.400', '&:hover': { color: 'grey.100' } }}
              >
                <SchoolIcon />
              </IconButton>
              <IconButton
                href="https://www.linkedin.com/in/zafer-c%C3%B6mert-51000367/"
                target="_blank"
                sx={{ color: 'grey.400', '&:hover': { color: 'grey.100' } }}
              >
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 5, pt: 2, borderTop: 1, borderColor: 'grey.800' }}>
          <Typography variant="body2" color="grey.400" align="center">
            {'© '}
            <Link 
              color="inherit" 
              href="https://github.com/zcomert"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              Dr. Zafer CÖMERT
            </Link>
            {' '}
            {new Date().getFullYear()}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
